/**
 * Утилиты для расчета позиций нот
 */

// Константы для позиционирования нот
export const NOTE_POSITION_CONSTANTS = {
    MAX_DISTANCE: -100,
    CLOSE_DISTANCE: -5,
    IMMEDIATE_DISTANCE: -2,
    MIN_TRAVEL_TIME: 0.1,
    DEFAULT_TRAVEL_TIME: 0.2,
    SPEED_MULTIPLIER: 2,
    LOW_SPEED_FACTOR: 0.1
};

/**
 * Рассчитывает начальную позицию ноты по оси Z
 * @param {number} timeUntilTarget - время до достижения цели в секундах
 * @param {number} effectiveUnitsPerSecond - эффективная скорость движения
 * @returns {number} начальная позиция по Z
 */
export function calculateInitialZPosition(timeUntilTarget, effectiveUnitsPerSecond) {
    if (timeUntilTarget <= 0) {
        return NOTE_POSITION_CONSTANTS.IMMEDIATE_DISTANCE;
    }

    if (timeUntilTarget < NOTE_POSITION_CONSTANTS.MIN_TRAVEL_TIME) {
        return NOTE_POSITION_CONSTANTS.CLOSE_DISTANCE;
    }

    const calculatedZ = -timeUntilTarget * effectiveUnitsPerSecond * NOTE_POSITION_CONSTANTS.SPEED_MULTIPLIER;
    return Math.max(NOTE_POSITION_CONSTANTS.MAX_DISTANCE, calculatedZ);
}

/**
 * Пересчитывает позицию с учетом нормализованного времени
 * @param {number} normalizedTime - нормализованное время движения
 * @param {number} effectiveUnitsPerSecond - эффективная скорость движения
 * @returns {number} пересчитанная позиция по Z
 */
export function recalculateZWithNormalizedTime(normalizedTime, effectiveUnitsPerSecond) {
    const calculatedZ = -normalizedTime * effectiveUnitsPerSecond * NOTE_POSITION_CONSTANTS.SPEED_MULTIPLIER;
    return Math.max(NOTE_POSITION_CONSTANTS.MAX_DISTANCE, calculatedZ);
}

/**
 * Нормализует время движения ноты
 * @param {number} timeUntilTarget - исходное время до цели
 * @returns {number} нормализованное время
 */
export function normalizeTravelTime(timeUntilTarget) {
    if (timeUntilTarget <= 0) {
        return NOTE_POSITION_CONSTANTS.DEFAULT_TRAVEL_TIME;
    }

    if (timeUntilTarget < NOTE_POSITION_CONSTANTS.MIN_TRAVEL_TIME) {
        return Math.max(timeUntilTarget, NOTE_POSITION_CONSTANTS.MIN_TRAVEL_TIME);
    }

    return timeUntilTarget;
}

